<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" class="mt-4">
      <b-col cols="10">
        <b-form inline>
          <b-input v-model="queryParam.criteria.username" placeholder="用户名" :cols="2"></b-input>
          <b-input v-model="queryParam.criteria.name" class="ml-3 mr-3" placeholder="姓名"></b-input>

          <date-range-picker
            ref="picker"
            opens="center"
            :locale-data="{ locale: daterange.local, format: 'yyyy-MM-dd' ,applyLabel:'确定',cancelLabel:'取消'}"
            :ranges="daterange.ranges"
            v-model="queryParam.criteria.daterange"
            style="min-width:180px;"
            placeholder="创建日期"
            class="mr-3"
          ></date-range-picker>
          <!-- <v-select
            name="hello"
            :options="['label1','label2']"
            placeholder="请选择日期"
            style="width:200px;"
          ></v-select>-->
          <!-- <b-input
          v-model="queryParam.criteria.daterange"
          class="ml-3 mr-3 daterange"
          placeholder="日期"
          ></b-input>-->
          <!-- <v-select
          name="hello"
          :options="['label1','label2']"
          placeholder="请选择日期"
          style="width:200px;"
          ></v-select>-->
          <!-- <b-datepicker
          style="width:200px;"
          id="startDate"
          v-model="queryParam.criteria.timeCreated"
          placeholder="开始日期"
          :max="maxDate"
          :disabled="false"
          :readonly="false"
        ></b-datepicker>
        <b-datepicker
          id="endDate"
          v-model="queryParam.criteria.timeCreated"
          placeholder="结束日期"
          :disabled="false"
          :readonly="false"
          ></b-datepicker>-->
          <b-button variant="outline-primary" @click="list(1)">查询</b-button>
        </b-form>
      </b-col>
      <b-col cols="2">
        <b-button variant="primary" @click="openAddDialog()" class="float-right">添加</b-button>
      </b-col>
    </b-row>

    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-4">
      <b-table
        id="data-table"
        responsive
        :fields="fields"
        :items="users.data"
        :busy="tableLoading"
        @sort-changed="sortTable"
        :show-empty="true"
        empty-text="暂无数据"
        :no-local-sorting="true"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <b-link @click="openUpdateDialog(row.index)" class="mr-1">编辑</b-link>
          <b-link @click="openResetPasswordDialog(row.index)" class="mr-1">重置密码</b-link>
          <b-link @click="openRemoveDialog(row.item)">删除</b-link>
        </template>
      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="users.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{users.totalElements}}&nbsp;条</div>
    </div>

    <!-- 添加窗口 -->
    <b-modal id="addModal" title="添加用户" incline v-model="addDialogVisible" @ok="handleAdd">
      <template slot="modal-ok">确定</template>
      <template slot="modal-cancel">取消</template>
      <validation-observer ref="addForm">
        <form>
          <validation-provider
            :rules="validators.rules.username"
            :customMessages="validators.msgs.username"
            name="用户名"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="2"
              label-align-sm="right"
              :invalid-feedback="validationContext.errors[0]"
            >
              <template slot="label">
                <span class="text-danger">*</span>用户名:
              </template>
              <b-form-input
                v-model="addParam.username"
                :state="validateState(validationContext)"
                ref="username"
              ></b-form-input>
            </b-form-group>
          </validation-provider>
          <validation-provider
            :rules="validators.rules.password"
            :customMessages="validators.msgs.password"
            name="密码"
            v-slot="validationContext"
            vid="password"
          >
            <b-form-group
              label-cols-sm="2"
              :invalid-feedback="validationContext.errors[0]"
              label-align-sm="right"
            >
              <template slot="label">
                <span class="text-danger">*</span>密码:
              </template>
              <b-form-input
                v-model="addParam.password"
                type="password"
                :state="validateState(validationContext)"
              ></b-form-input>
            </b-form-group>
          </validation-provider>
          <validation-provider
            :rules="validators.rules.confirmPassword"
            :customMessages="validators.msgs.confirmPassword"
            name="密码"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="2"
              :invalid-feedback="validationContext.errors[0]"
              label-align-sm="right"
            >
              <template slot="label">
                <span class="text-danger">*</span>确认密码:
              </template>
              <b-form-input
                v-model="addParam.confirmPassword"
                type="password"
                :state="validateState(validationContext)"
                required
              ></b-form-input>
            </b-form-group>
          </validation-provider>
          <validation-provider
            :rules="validators.rules.name"
            :customMessages="validators.msgs.name"
            name="姓名"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="2"
              :invalid-feedback="validationContext.errors[0]"
              label-align-sm="right"
            >
              <template slot="label">
                <span class="text-danger">*</span>姓名:
              </template>
              <b-form-input
                v-model="addParam.name"
                type="text"
                :state="validateState(validationContext)"
                required
              ></b-form-input>
            </b-form-group>
          </validation-provider>
          <validation-provider
            :rules="validators.rules.email"
            :customMessages="validators.msgs.email"
            name="邮箱"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="2"
              :invalid-feedback="validationContext.errors[0]"
              label-align-sm="right"
            >
              <template slot="label">
                <span class="text-danger">*</span>邮箱地址:
              </template>
              <b-form-input
                v-model="addParam.email"
                type="text"
                :state="validateState(validationContext)"
                required
              ></b-form-input>
            </b-form-group>
          </validation-provider>
          <validation-provider
            :rules="validators.rules.role"
            :customMessages="validators.msgs.role"
            name="角色"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="2"
              :invalid-feedback="validationContext.errors[0]"
              label-align-sm="right"
            >
              <template slot="label">
                <span class="text-danger">*</span>角色:
              </template>
              <b-form-radio-group v-model="addParam.role" :state="validateState(validationContext)">
                <b-form-radio value="管理员">管理员</b-form-radio>
                <b-form-radio value="普通用户">普通用户</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </validation-provider>
        </form>
      </validation-observer>
    </b-modal>

    <!-- 修改窗口 -->
    <b-modal id="updateModal" title="编辑用户" incline v-model="updateDialogVisible" @ok="handleUpdate">
      <template slot="modal-ok">确定</template>
      <template slot="modal-cancel">取消</template>
      <validation-observer ref="updateForm">
        <form>
          <validation-provider
            :rules="validators.rules.name"
            :customMessages="validators.msgs.name"
            name="姓名"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="2"
              :invalid-feedback="validationContext.errors[0]"
              label-align-sm="right"
            >
              <template slot="label">
                <span class="text-danger">*</span>姓名:
              </template>
              <b-form-input
                v-model="updateParam.name"
                type="text"
                :state="validateState(validationContext)"
                required
              ></b-form-input>
            </b-form-group>
          </validation-provider>
          <validation-provider
            :rules="validators.rules.email"
            :customMessages="validators.msgs.email"
            name="邮箱"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="2"
              :invalid-feedback="validationContext.errors[0]"
              label-align-sm="right"
            >
              <template slot="label">
                <span class="text-danger">*</span>邮箱地址:
              </template>
              <b-form-input
                v-model="updateParam.email"
                type="text"
                :state="validateState(validationContext)"
                required
              ></b-form-input>
            </b-form-group>
          </validation-provider>
          <validation-provider
            :rules="validators.rules.role"
            :customMessages="validators.msgs.role"
            name="角色"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="2"
              :invalid-feedback="validationContext.errors[0]"
              label-align-sm="right"
            >
              <template slot="label">
                <span class="text-danger">*</span>角色:
              </template>
              <b-form-radio-group
                v-model="updateParam.role"
                :state="validateState(validationContext)"
              >
                <b-form-radio value="管理员">管理员</b-form-radio>
                <b-form-radio value="普通用户">普通用户</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </validation-provider>
        </form>
      </validation-observer>
    </b-modal>

    <!-- 删除用户窗口 -->

    <!-- 重置密码窗口 -->
    <b-modal
      id="resetModal"
      title="重置密码"
      incline
      v-model="resetPasswordDialogVisible"
      @ok="handleResetPassword"
    >
      <template slot="modal-ok">确定</template>
      <template slot="modal-cancel">取消</template>
      <validation-observer ref="resetForm">
        <form>
          <validation-provider
            :rules="validators.rules.password"
            :customMessages="validators.msgs.password"
            name="新密码"
            v-slot="validationContext"
            vid="password"
          >
            <b-form-group
              label-cols-sm="2"
              :invalid-feedback="validationContext.errors[0]"
              label-align-sm="right"
            >
              <template slot="label">
                <span class="text-danger">*</span>新密码:
              </template>
              <b-form-input
                v-model="resetPasswordParam.password"
                type="password"
                :state="validateState(validationContext)"
              ></b-form-input>
            </b-form-group>
          </validation-provider>
          <validation-provider
            :rules="validators.rules.confirmPassword"
            :customMessages="validators.msgs.confirmPassword"
            name="密码"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="2"
              :invalid-feedback="validationContext.errors[0]"
              label-align-sm="right"
            >
              <template slot="label">
                <span class="text-danger">*</span>确认密码:
              </template>
              <b-form-input
                v-model="resetPasswordParam.confirmPassword"
                type="password"
                :state="validateState(validationContext)"
                required
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </form>
      </validation-observer>
    </b-modal>
    <loading :show="pageLoading"></loading>
  </div>
</template>

<script>
import * as userFacade from "../../../api/user-facade.js";
import { zhCN } from "date-fns/locale";
import {
  addDays,
  startOfMonth,
  startOfYear,
  endOfMonth,
  addMonths,
  endOfYear,
  startOfWeek,
  endOfWeek,
  addWeeks
} from "date-fns/esm";

import dayjs from "dayjs";
let passwordPattern = /^[A-Za-z0-9_!@#$%^&*`~()\-+=]+$/;
let passwordMessage = "只能包含半角数字、半角英文字母和符号";
const now = new Date();
const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

export default {
  // validations:
  data() {
    return {
      daterange: {
        local: zhCN,
        locale: {
          localize: "zhCN",
          //汉化
          format: "YYYY-MM-DD HH:mm:ss", //设置显示格式
          applyLabel: "确定", //确定按钮文本
          cancelLabel: "取消", //取消按钮文本
          daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
          monthNames: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ],
          firstDay: 1
        },
        dateFormat: "yyyy-MM-dd",
        ranges: {
          今天: [new Date(), new Date()],
          昨天: [addDays(new Date(), -1), addDays(new Date(), -1)],
          本月: [startOfMonth(new Date()), endOfMonth(new Date())],
          本年: [startOfYear(new Date()), endOfYear(new Date())],
          上一周: [
            addDays(startOfWeek(addWeeks(new Date(), -1)), 1),
            addDays(endOfWeek(addWeeks(new Date(), -1)), 1)
          ],
          上一月: [
            startOfMonth(addMonths(new Date(), -1)),
            endOfMonth(addMonths(new Date(), -1))
          ]
        }
      },
      sortBy: "timeCreated",
      sortDesc: true,
      maxDate: today,
      startDate: null,
      endDate: null,
      fields: [
        { key: "username", label: "用户名" },
        { key: "name", label: "姓名" },
        { key: "role", label: "角色" },
        { key: "email", label: "邮箱" },
        {
          key: "timeCreated",
          label: "创建时间",
          sortable: true,
          sortDirection: "desc",
          formatter: value => {
            return value != null
              ? dayjs(new Date(value)).format("YYYY-MM-DD HH:mm:ss")
              : "";
          }
        },
        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      users: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 10,
        page: 1,
        criteria: {
          username: "",
          name: "",
          daterange: "",
          timeCreated: []
        },
        sortOrder: { timeCreated: "descending" }
      },

      addParam: {
        username: "",
        password: "",
        confirmPassword: "",
        name: "",
        email: "",
        role: "管理员"
      },
      updateParam: {
        name: "",
        email: "",
        role: ""
      },
      resetPasswordParam: {
        password: "",
        confirmPassword: ""
      },
      // 以上为数据展示和传输对象

      // 以下为页面状态控制参数
      pageLoading: false,
      tableLoading: false, // 表格Loading状态
      updateDialogVisible: false, // 修改窗口显示状态
      addDialogVisible: false, // 添加窗口显示状态
      resetPasswordDialogVisible: false, // 重置密码窗口显示状态
      removeDialogVisible: false, // 删除提示框显示状态

      opIndex: -1, // 当前操作的表格行索引
      // 以上为页面状态控制参数

      // 以下为表单校验规则
      validators: {
        rules: {
          username: {
            required: true,
            min: 6,
            max: 20,

            regex: /^[A-Za-z0-9]+$/
          },
          password: {
            required: true,
            min: 8,
            max: 20,
            regex: passwordPattern
          },
          confirmPassword: {
            required: true,
            confirmed: "password"
          },
          role: {
            required: true
          },
          name: {
            required: true,
            min: 2,
            max: 20
          },
          email: {
            required: true,
            email: true,
            max: 100
          }
        },
        msgs: {
          username: {
            min: "长度在6到20个字符",
            max: "长度在6到20个字符",
            regex: "只能包含半角英文字母和数字"
          },
          password: {
            min: "长度在8到20个字符",
            max: "长度在8到20个字符",
            regex: passwordMessage
          },

          confirmPassword: {
            required: "请输入确认密码",
            confirmed: "两次输入密码不一致"
          },
          role: {
            required: "请选择角色"
          },
          name: {
            required: "请输入姓名",
            min: "长度在2到20个字符",
            max: "长度在2到20个字符"
          },
          email: {
            email: "不是合法的邮件地址"
          }
        }
      }

      // 以上为表单校验规则
    };
  },
  watch: {},
  mounted() {
    // 异步加载列表数据
    this.handleQuery();
    // 异步加载检索条件中的“纳税人”下拉菜单
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    // 异步加载列表数据
    list(page) {
      console.log(this.queryParam.criteria.daterange);
      if (this.queryParam.criteria.daterange) {
        this.queryParam.criteria.timeCreated[0] = this.queryParam.criteria.daterange.startDate;
        this.queryParam.criteria.timeCreated[1] = this.queryParam.criteria.daterange.endDate;

        // this.queryParam.criteria.timeCreated[1] = new Date(
        //   this.queryParam.criteria.timeCreated[1] + " 59:59:59"
        // );
      }
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      userFacade
        .list(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.users = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    // 表格数据排序
    sortTable(column) {
      this.queryParam.page = 1;
      if (column.sortDesc) {
        this.queryParam.sortOrder[column.sortBy] = "descending";
      } else {
        this.queryParam.sortOrder[column.sortBy] = "ascending";
      }
      this.list();
    },
    // 打开添加窗口
    openAddDialog() {
      this.addDialogVisible = true;
      this.$nextTick(() => {
        Object.assign(this.$data.addParam, this.$options.data().addParam);
      });
    },
    // 打开编辑窗口
    openUpdateDialog(index) {
      this.updateDialogVisible = true;
      this.opIndex = index;
      let updateUser = this.users.data[index];
      this.updateParam.name = updateUser.name;
      this.updateParam.email = updateUser.email;
      this.updateParam.role = updateUser.role;
    },
    // 打开重置密码窗口
    openResetPasswordDialog(index) {
      this.resetPasswordDialogVisible = true;
      this.opIndex = index;
      this.$nextTick(() => {
        Object.assign(
          this.$data.resetPasswordParam,
          this.$options.data().resetPasswordParam
        );
      });
    },
    // 打开删除对话框
    openRemoveDialog(item) {
      this.$bvModal
        .msgBoxConfirm("确认删除用户吗？", {
          title: "删除用户",
          size: "sm",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "删除",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if (value) {
            this.handleRemove(item.id);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 执行查询操作
    handleQuery() {
      this.sortDesc = true;
      this.queryParam.page = 1;
      this.queryParam.sortOrder = {};
      this.queryParam.sortOrder.timeCreated = "descending";

      this.list();
    },
    // 执行添加操作
    handleAdd(e) {
      e.preventDefault();

      //this.nameState = this.$refs.form.checkValidity();
      this.$refs.addForm.validate().then(success => {
        if (!success) {
          return;
        }
        this.pageLoading = true;
        userFacade
          .add(this.addParam)
          /* eslint-disable */
          .then(res => {
            this.pageLoading = false;
            this.addDialogVisible = false;
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.list();
          })
          .catch(err => {
            this.pageLoading = false;
            console.log("err", err);
          });
        this.$nextTick(() => {
          this.$refs.addForm.reset();
        });
      });
    },
    // 执行修改操作
    handleUpdate(e) {
      e.preventDefault();

      this.$refs.updateForm.validate().then(valid => {
        if (valid) {
          this.pageLoading = true;
          userFacade
            .update(this.users.data[this.opIndex].id, this.updateParam)
            .then(res => {
              /* eslint-disable */
              this.pageLoading = false;
              this.updateDialogVisible = false;
              this.$set(this.users.data, this.opIndex, res);
              this.$message({
                message: "修改成功",
                type: "success"
              });
            })
            .catch(err => {
              this.pageLoading = false;
              console.log("err", err);
            });
          this.$nextTick(() => {
            this.$refs.updateForm.reset();
          });
        } else {
          return false;
        }
      });
    },
    // 执行重置密码操作
    handleResetPassword(e) {
      e.preventDefault();
      this.$refs.resetForm.validate().then(valid => {
        if (valid) {
          this.pageLoading = true;
          userFacade
            .resetPassword(
              this.users.data[this.opIndex].id,
              this.resetPasswordParam
            )
            .then(res => {
              this.pageLoading = false;
              this.resetPasswordDialogVisible = false;
              this.$message({
                message: "密码重置成功",
                type: "success"
              });
            })
            .catch(err => {
              console.log("err", err);
            });
          this.$nextTick(() => {
            this.$refs.resetForm.reset();
          });
        } else {
          return false;
        }
      });
    },
    // 执行删除操作
    handleRemove(id) {
      this.pageLoading = true;
      userFacade
        .remove(id)
        .then(res => {
          this.pageLoading = false;
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.list();
        })
        .catch(err => {
          this.pageLoading = false;
          console.log("err", err);
        });
    }
  }
};
</script>

<style>
.actions {
  width: 150px;
}
.vs__dropdown-toggle {
  height: 33.5px;
}
</style>
